var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhoneIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "19px",
    viewBox: "0 0 13 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "605ECF0E-CC50-4B50-8FF3-2AA2CF99ADB2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components-Prototype",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13.X.18-Blueprints---Components---New-Component---Component-Fixed",
    transform: "translate(-673.000000, -277.000000)",
    fill: "#4A4A4A",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(660.000000, 266.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: 4,
    points: "23.119897 29.4 23.119897 24 25.592 24 25.592 21.3514286 23.119897 21.3514286 23.119897 15.9514286 20.1585236 15.9514286 20.1585236 21.3514286 16.5533734 21.3514286 16.5533734 11.4 13.592 11.4 13.592 24 20.1585236 24 20.1585236 29.4"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phoneIcon.1afe91b555de9876d4946a98e31f6b07.svg";